import { Component } from '@angular/core';

@Component({
    selector: 'app-details-header',
    standalone: true,
    imports: [],
    templateUrl: './details-header.component.html',
    styleUrl: './details-header.component.scss',
})
export class DetailsHeaderComponent {}
